module.exports = __webpack_public_path__ + "static/media/sold_out_ar.2cd03e30.png";